import { ICartEntry, IDiscount } from '@rbi-ctg/menu';
import { DiscountTypes } from 'enums/menu';
import { ISelectedOfferPersistedState } from 'state/offers/hooks/types';
import { priceForCartEntry } from 'utils/menu/price';

export const computeCartTotal = (
  { selectedOffer, selectedOfferCartEntry, selectedOfferPrice }: ISelectedOfferPersistedState,
  cartEntries: Array<ICartEntry>
) => {
  const cartEntriesWithOffer = selectedOffer
    ? [...cartEntries, { ...selectedOfferCartEntry, price: selectedOfferPrice }]
    : cartEntries;

  return cartEntriesWithOffer.reduce(
    (totalPrice: number, entry: ICartEntry) => priceForCartEntry(entry) + totalPrice,
    0
  );
};

export const computeOtherDiscountAmount = (allDiscounts?: IDiscount[]) => {
  if (!allDiscounts) {
    return 0;
  }
  return allDiscounts
    .filter(discount => discount.name !== DiscountTypes.REWARDS_DISCOUNTS)
    .reduce((acc, curr) => curr.value + acc, 0);
};

export const computeDeliveryFee = ({
  feeCents,
  feeDiscountCents,
  serviceFeeCents,
  smallCartFeeCents
}: {
  feeCents: number | null;
  feeDiscountCents: number | null;
  serviceFeeCents: number | null;
  smallCartFeeCents: number | null;
}) => {
  // The value "feeCents" includes the additional fees "serviceFeeCents" and "smallCartFeeCents"
  return Math.max(
    (feeCents || 0) - (feeDiscountCents || 0) - (serviceFeeCents || 0) - (smallCartFeeCents || 0),
    0
  );
};
